import 'BrokerTsLib/src/extensions/date.extensions'

import { Badge } from '@chakra-ui/react'
import { useEffect } from 'react'

import { useApp } from '@/hooks/useApp'

import { Card, CardBody, CardTitle } from '../../../components/Card'
import { ContractsList } from '../../../containers/contracts'
import { useAuth } from '../../../context/AuthContext'
import { useGetAll } from '../../../hooks/useInsuranceParams'

function AnniversaryWidget() {
  const { user } = useAuth()!
  const { product } = useApp()

  const pageSize = 5

  const filter = {
    anniversaryFrom: new Date(),
    anniversaryTo: new Date().customAddDays(70),
    listType: 2,
    pageIndex: 1,
    pageSize
  }

  const { data, mutateAsync, isLoading: isLoading } = useGetAll()
  const concepts = data?.data

  const items = concepts?.items ?? []

  useEffect(() => {
    if (!user?.id) return

    mutateAsync(filter)
  }, [user?.id, product])

  return (
    <Card>
      <CardTitle>
        Blížící se výročí smluv
        {!isLoading && items.length > 0 && <Badge>{items.length} / {concepts?.totalCount}</Badge>}
      </CardTitle>

      <CardBody sx={{ p: 0 }}>
        <ContractsList contracts={items} loading={isLoading} />
      </CardBody>
    </Card>
  )
}

export default AnniversaryWidget